import { render, staticRenderFns } from "./editPosition.vue?vue&type=template&id=50c017cc&scoped=true&"
import script from "./editPosition.vue?vue&type=script&lang=js&"
export * from "./editPosition.vue?vue&type=script&lang=js&"
import style0 from "./editPosition.vue?vue&type=style&index=0&id=50c017cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c017cc",
  null
  
)

export default component.exports